import {
	equal,
	integer,
	min,
	required,
	string,
	length,
} from 'vue-mc/validation';
import Model from './Model';
import Collection from './Collection';

export class CustomData extends Model {
	static FIELD_TYPES = [
		{ value: 'checkbox', text: 'Checkbox' },
		{ value: 'textInput', text: 'Text' },
		{ value: 'textarea', text: 'Textarea' },
		{ value: 'dropdownList', text: 'Dropdown' },
		// { value: 'multiselect', text: 'Multiselect' },
	];

	defaults() {
		return {
			id: null,
			label: '',
			type: '',
		};
	}

	mutations() {
		return {
			id: id => Number(id) || null,
			label: String,
			type: String,
		};
	}

	validation() {
		return {
			id: integer.and(min(1)).or(equal(null)),
			label: string.and(required).and(length(1, 100)),
			type: string.and(required),
		};
	}

	routes() {
		return {
			create: '/custom-datas',
			fetch: '/custom-datas/{id}',
			patch: '/custom-datas/{id}',
			delete: '/custom-datas/{id}',
			completion: '/custom-datas/{id}/completion',
		};
	}

	options() {
		return {
			patch: true,
		};
	}

	get typeText() {
		const fieldType = CustomData.FIELD_TYPES.find(type => type.value === this.type);

		return fieldType ? fieldType.text : '';
	}

	get showItems() {
		return ['dropdownList'].includes(this.type);
	}
}

export class CustomDatas extends Collection {
	model() {
		return CustomData;
	}

	routes() {
		return {
			fetch: '/custom-datas?projectId={projectId}',
		};
	}
}

export class CustomDataItem extends Model {
	defaults() {
		return {
			label: '',
			order: null,
			parentId: null,
			value: '',
		};
	}

	mutations() {
		return {
			parentId: id => Number(id) || null,
			label: String,
			value: String,
		};
	}

	validation() {
		return {
			parentId: integer.and(required),
			label: string.and(required).and(length(1, 100)),
		};
	}

	routes() {
		return {
			create: 'custom-data-items',
			patch: 'custom-data-items/{value}?parentId={parentId}',
			delete: 'custom-data-items/{value}?parentId={parentId}',
		};
	}

	options() {
		return {
			identifier: 'value',
			patch: true,
		};
	}

	isNew() {
		return this.value === '';
	}
}

export class CustomDataItems extends Collection {
	model() {
		return CustomDataItem;
	}

	routes() {
		return {
			fetch: 'custom-data-items?parentId={parentId}',
		};
	}
}
